import learningMaterial from 'ApiService/Teacher/learningMaterial';
import Card from 'components/card';
import { useFormKeyboardSubmit } from 'pages/Hooks/useStepperKeyboardNavigation';
import { useState } from 'react';
import toast from 'react-hot-toast';
import AddInfo from './Steps/AddInfo';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [resetFlag, setResetFlag] = useState(false);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    courseId: '',
    batchStructureId: '',
    batchId: '',
    title: '',
    url: '',
    description: '',
  });
  const [isModalOpenConfirmation, setIsModalOpenConfirmation] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleConfirmSubmit = () => {
    const isValid =
      formData.courseId &&
      formData.batchStructureId &&
      formData.batchId &&
      formData.title &&
      formData.url;

    if (isValid) {
      setIsModalOpenConfirmation(true);
    } else {
      toast.error('Please complete all required fields.');
    }
  };

  async function handleSubmit() {
    if (loading) return;

    if (
      formData.courseId &&
      formData.batchStructureId &&
      formData.batchId &&
      formData.title &&
      formData.url
    ) {
      setLoading(true);
      try {
        const response = await learningMaterial.createTrainingMaterialUrl(
          formData
        );
        if (response.data.success) {
          setResetFlag((prev) => !prev);
          setIsModalOpenConfirmation(false);
          setFormData({
            courseId: '',
            batchStructureId: '',
            batchId: '',
            title: '',
            url: '',
            description: '',
          });
          toast.success(response?.data?.message);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('All fields are required.');
    }
  }

  useFormKeyboardSubmit(handleSubmit, disable, loading);

  return (
    <div className="mt-3 h-full w-full">
      <>
        <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />

        <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
          <Card
            extra={
              ' -mt-[280px] w-full md:-mt-[240px] md:px-[70px] h-full mx-auto pb-3'
            }
          >
            <div className="rounded-[20px]">
              <AddInfo
                setLoading={setLoading}
                setDisable={setDisable}
                handleInputChange={handleInputChange}
                formData={formData}
                setFormData={setFormData}
                resetFlag={resetFlag}
              />
            </div>
            {disable && (
              <p className="mt-2 text-sm text-red-500">
                Please complete all required fields
              </p>
            )}

            <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
              <button
                disabled={disable}
                onClick={handleConfirmSubmit}
                className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
              >
                {loading ? 'Loading..' : 'Assign URL'}
              </button>
            </div>
          </Card>
        </div>
      </>
      <ConfirmationModal
        isOpen={isModalOpenConfirmation}
        onClose={() => setIsModalOpenConfirmation(false)}
        onConfirm={handleSubmit}
        title="Confirm Assign Training Material URL"
        message="Are you sure you want to assign this URL to the selected batch?"
        confirmText={loading ? 'Assigning...' : 'Yes, Assign URL'}
        cancelText="Cancel"
        icon="info"
        disableConfirm={loading}
      />
    </div>
  );
};

export default Index;
